import type { EnvironmentState } from 'store/slices/environment/slice';

export type ExternalRequestEnv = 'prod' | 'demo' | 'dev1';

export const getExternalRequestEnv = (namespace: EnvironmentState['REACT_APP_NAMESPACE'] | undefined): ExternalRequestEnv => {
  if (namespace === 'biz-tecma-prod') {
    return 'prod';
  }
  if (namespace === 'biz-tecma-demo-prod') {
    return 'demo';
  }

  return 'dev1';
};
